import {Brick, registerBrick} from 'olympe';

/**
 * The has method of Set instances check if a value is in a Set.
 */
export default class SetHas extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Set} set
     * @param {string} value
     * @param {function()} forwardEvent
     * @param {function(boolean)} setHas
     */
    update($, [set, value], [forwardEvent, setHas]) {
        setHas(set.has(value));
        forwardEvent();
    }
}

registerBrick('018a6f113641c678466f', SetHas);
